module.exports = __webpack_public_path__ + "static/media/new1.cc4dc534.png";